const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "objects",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356 450.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 178,
    cy: 434.66,
    rx: 129.48,
    ry: 15.43,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.37,470.15l36.72-20C426.57,405.27,478,318.23,478,223.54v-95.6a13.72,13.72,0,0,0-13.19-13.82c-86.78-2.38-140.62-27.7-158.34-37.5a13.4,13.4,0,0,0-12.94,0c-17.72,9.8-71.56,35.12-158.34,37.5A13.72,13.72,0,0,0,122,127.94v95.6c0,94.69,51.43,181.73,133.91,226.62l36.72,20A15.37,15.37,0,0,0,307.37,470.15Z",
    transform: "translate(-122 -74.95)",
    style: {
      fill: "#dadadb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.4,139.2v81.12c0,90.31-48.81,173-127.38,215.73l-26,14.18a14.61,14.61,0,0,1-13.94,0l-26-14.18C188.41,393.28,139.6,310.63,139.6,220.32V139.2a7.33,7.33,0,0,1,6.86-7.25c73.92-5,124.68-24.62,150.36-37.16a7,7,0,0,1,6.36,0c25.68,12.54,76.45,32.13,150.36,37.16A7.33,7.33,0,0,1,460.4,139.2Z",
    transform: "translate(-122 -74.95)",
    style: {
      fill: "#21a2db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.4,139.2v81.12c0,90.31-48.81,173-127.38,215.73l-26,14.18a14.7,14.7,0,0,1-7,1.77V94a7.11,7.11,0,0,1,3.18.76c25.68,12.54,76.45,32.13,150.36,37.16A7.33,7.33,0,0,1,460.4,139.2Z",
    transform: "translate(-122 -74.95)",
    style: {
      fill: "#158cb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,240.92H239a13.17,13.17,0,0,0-13.16,13.16v97.27A13.17,13.17,0,0,0,239,364.51H361a13.17,13.17,0,0,0,13.16-13.16V254.08A13.17,13.17,0,0,0,361,240.92Zm-49.23,68v9.73a11.77,11.77,0,0,1-23.54,0v-9.73a20,20,0,1,1,23.54,0Z",
    transform: "translate(-122 -74.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,204.48v15.25a9.41,9.41,0,0,1-9.41,9.42h0a9.42,9.42,0,0,1-9.42-9.42V205.08c0-13.38-10.39-24.8-23.77-25.3a24.74,24.74,0,0,0-25.67,24.7v27H256.45V205.19c0-23.74,18.7-43.65,42.43-44.25a43.56,43.56,0,0,1,44.67,43.54Z",
    transform: "translate(-122 -74.95)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.1bc4ed2937d40525fc9fddb1488cccd0.svg";
export { ForwardRef as ReactComponent };